import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconWhatsappBrandedStyle0 = cosmosIconCss;

const CosmosIconWhatsappBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWhatsappBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b572e98dc260c30cbae2a089f4b1b75a29b9db87', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3d39a180f31893b2d424c5093d4022c19b0094f0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'd4de24d330e5367e18c991b6c22a2320c6bd0f93', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.29 4.609a8.935 8.935 0 0 0-14.05 10.79L2 20l4.702-1.251a8.936 8.936 0 0 0 4.233 1.117 8.936 8.936 0 0 0 6.356-15.257Zm-6.355 13.738a7.36 7.36 0 0 1-3.775-1.039l-.268-.156-2.815.737.76-2.736-.179-.29a7.305 7.305 0 0 1-1.117-3.944 7.428 7.428 0 0 1 7.394-7.416 7.417 7.417 0 0 1 7.45 7.428 7.427 7.427 0 0 1-7.45 7.416Zm4.077-5.585c-.223-.111-1.318-.648-1.53-.726-.212-.078-.346-.111-.503.112-.156.223-.57.726-.703.882-.134.157-.257.168-.48 0a6.187 6.187 0 0 1-1.799-1.117 6.947 6.947 0 0 1-1.24-1.552.335.335 0 0 1 .101-.458c.12-.124.231-.254.335-.391.091-.112.167-.236.223-.369a.402.402 0 0 0 0-.39c-.044-.056-.491-1.117-.714-1.564-.224-.447-.369-.38-.503-.38h-.391a.827.827 0 0 0-.592.28 2.513 2.513 0 0 0-.748 1.853 4.3 4.3 0 0 0 .916 2.301 10.052 10.052 0 0 0 3.808 3.351c.537.223.95.357 1.274.47.456.139.938.165 1.407.077a2.234 2.234 0 0 0 1.497-1.05c.148-.332.195-.701.134-1.06-.1-.079-.235-.135-.458-.246l-.034-.023Z", fill: "#25D366" }))));
    }
    static get style() { return CosmosIconWhatsappBrandedStyle0; }
}, [1, "cosmos-icon-whatsapp-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-whatsapp-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-whatsapp-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWhatsappBranded$1);
            }
            break;
    } });
}

const CosmosIconWhatsappBranded = CosmosIconWhatsappBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWhatsappBranded, defineCustomElement };
